// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3OCvb","calendarButtons":"ClockData_calendarButtons__ky03I"};